import { useQuery } from "@apollo/client";

import { webAgent__EndpointType } from "@medbillai/generated-graphql-types";

import { errorHandling } from "../../lib/apollo/utils";
import { linksQuery } from "../accounts-link/utils/queries";

type WebAgentLinkStatus = {
  active: boolean;
  endpoint: { type: webAgent__EndpointType };
};

/** An active web-agent link to an insurer; a web-agent link can also be a patient portal. */
export const isInsurerPortalLink = (link: WebAgentLinkStatus): boolean =>
  link.active && link.endpoint.type !== webAgent__EndpointType.EHR;

export const useInsuranceLinked = (): boolean | undefined => {
  const { data } = useQuery(linksQuery, { context: errorHandling("caller") });
  const me = data?.me;
  // Flexpa only links insurers.
  return me
    ? (me.flexpaLinks ?? []).some(l => l.active) ||
        (me.webAgentLinks ?? []).some(isInsurerPortalLink)
    : undefined;
};
